/**
 * Arrow direction
 */
export var ArrowDirection;
(function (ArrowDirection) {
    ArrowDirection["UP"] = "top";
    ArrowDirection["BOTTOM"] = "bottom";
    ArrowDirection["LEFT"] = "left";
    ArrowDirection["RIGHT"] = "right";
})(ArrowDirection || (ArrowDirection = {}));
/**
 * Arrow align
 */
export var ArrowAlign;
(function (ArrowAlign) {
    ArrowAlign["ONE_FIFTH"] = "one-fifth";
    ArrowAlign["ONE_QUARTER"] = "one-quarter";
    ArrowAlign["ONE_THRID"] = "one-thrid";
    ArrowAlign["TWO_FIFTHS"] = "two-fifths";
    ArrowAlign["THREE_FIFTHS"] = "three-fifths";
    ArrowAlign["TWO_THIRDS"] = "two-thirds";
    ArrowAlign["THREE_QUARTERS"] = "three-quarters";
    ArrowAlign["FOUR_FIFTHS"] = "four-fifths";
})(ArrowAlign || (ArrowAlign = {}));
/**
 * Avatar direction
 */
export var AvatarDirection;
(function (AvatarDirection) {
    AvatarDirection["LEFT"] = "left";
    AvatarDirection["RIGHT"] = "right";
})(AvatarDirection || (AvatarDirection = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUHJvZHVjdFRvdXJQcm9wcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2NvbXBvbmVudHMvcHJvZHVjdC10b3VyL1Byb2R1Y3RUb3VyUHJvcHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR0E7O0dBRUc7QUFDSCxNQUFNLENBQU4sSUFBWSxjQUtYO0FBTEQsV0FBWSxjQUFjO0lBQ3hCLDRCQUFVLENBQUE7SUFDVixtQ0FBaUIsQ0FBQTtJQUNqQiwrQkFBYSxDQUFBO0lBQ2IsaUNBQWUsQ0FBQTtBQUNqQixDQUFDLEVBTFcsY0FBYyxLQUFkLGNBQWMsUUFLekI7QUFPRDs7R0FFRztBQUNILE1BQU0sQ0FBTixJQUFZLFVBU1g7QUFURCxXQUFZLFVBQVU7SUFDcEIscUNBQXVCLENBQUE7SUFDdkIseUNBQTJCLENBQUE7SUFDM0IscUNBQXVCLENBQUE7SUFDdkIsdUNBQXlCLENBQUE7SUFDekIsMkNBQTZCLENBQUE7SUFDN0IsdUNBQXlCLENBQUE7SUFDekIsK0NBQWlDLENBQUE7SUFDakMseUNBQTJCLENBQUE7QUFDN0IsQ0FBQyxFQVRXLFVBQVUsS0FBVixVQUFVLFFBU3JCO0FBT0Q7O0dBRUc7QUFDSCxNQUFNLENBQU4sSUFBWSxlQUdYO0FBSEQsV0FBWSxlQUFlO0lBQ3pCLGdDQUFhLENBQUE7SUFDYixrQ0FBZSxDQUFBO0FBQ2pCLENBQUMsRUFIVyxlQUFlLEtBQWYsZUFBZSxRQUcxQiJ9